import React from "react";
import styled from "styled-components";

const Title = ({ titleText = "", titleClassName = "" }) => {
  return <TitleWrap className={titleClassName}>{titleText}</TitleWrap>;
};

const TitleWrap = styled.h2`
    font-style: normal;
    font-weight: 400;
    font-size: 36px;
    line-height: 57px;
    color: #022142;
    margin-bottom: 80px;
  @media only screen and (min-width: 769px) and (max-width: 1024px) {
    margin-bottom: 40px;
  }
  @media only screen and (max-width: 768px) {
    margin-bottom: 8px
  }
  @media only screen and (max-width: 600px) {
      font-size: 24px;
      line-height: 32px;
    }
`;
export default Title